import "./solicitudCarrera.scss";
import { Formik, Form, ErrorMessage, Field } from "formik";
//import Button from "../../components/atoms/buttons/Button";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import {
  getBorrador,
  insertSolicitudReconocimiento,
  presentarSolicitud,
  updateBorrador,
  updateSolicitudPresentada,
} from "../../components/services/ReconocimientoNivelService";
import { SpinnerCircleMini } from "../../components/atoms/spinner/Spinner";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import { useLocalStorage } from "../../hooks/useLocalStorage";

const SolicitudCarrera = () => {
  const [show, setShow] = useState({
    mensaje: false,
  });
  //   const [isInitialRender, setIsInitialRender] = useState({
  //     personal: true,
  //     borrador: false,
  //   });
  const [loading, setLoading] = useState(false);
  const [loadingBoton, setLoadingBoton] = useState(false);
  const [loadingBotonSolicitar, setLoadingBotonSolicitar] = useState(false);
  const [doeMostrar, setDoeMostrar] = useState(true);
  const [formacionMostrar, setFormacionMostrar] = useState(true);
  const [transferenciaMostrar, setTransferenciaMostrar] = useState(true);
  const [participacionMostrar, setParticipacionMostrar] = useState(true);
  const [disablePresentar, setDisablePresentar] = useState(false);
  const [user] = useLocalStorage("user", "");
  // let navigate = useNavigate();

  const [borrador, setBorrador] = useState(false);

  const [accesoConcurso] = useState(true);
  const dt = new Date();

  const [datos, setDatos] = useState({
    codSolicitud: 0,
    nombre: "",
    ape1: "",
    ape2: "",
    dni: "",
    domicilio: "",
    cp: "",
    localidad: "",
    provincia: "",
    tlf: "",
    email: "",
    a1: false,
    a2: false,
    a3: false,
    doe: [
      {
        id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
        value: "",
      },
    ],
    formacion: [
      {
        id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
        value: "",
      },
    ],
    transferencia: [
      {
        id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
        value: "",
      },
    ],
    participacion: [
      {
        id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
        value: "",
      },
    ],
    estado: "",
  });

  const presentar = (valores) => {
    setLoadingBoton(true);
    presentarSolicitud(valores).then((data) => {
      
      
      setShow({
        mensaje: true,
        content: data,
        tipo: "tituloModal",
        boton: "Aceptar ",
        destinoAviso: null,
        destinoCerrar: "/carrera",
        stateParams: { solPresentada: true, codSolicitud: datos?.codSolicitud },
      });

      setLoadingBoton(false);
    });
  };

  const handleClose = (e) => {
    setShow(false);
  };

  //Elimina un objeto en concreto (index) de un array de objetos (general, setgeral), con un estado de carga(setGeneralMostrar)
  const eliminarGeneral = (id, setGeneralMostrar, general, tipo) => {
    setGeneralMostrar(false);
    new Promise((resolve) => {
      general = general.filter((item) => item.id !== id);
      
      setDatos((prevState) => ({
        ...prevState,
        [tipo]: general,
      }));
      resolve();
    }).then(() => setGeneralMostrar(true));
  };

  const anadirInput = (datosInput, name) => {
    datosInput.push({
      id: Math.round(dt.getTime() / Math.floor(Math.random() * 100)),
      value: "",
    });

    setDatos((prevState) => ({
      ...prevState,
    }));
  };

  const mantenerBorrador = (datos) => {
    
    
    setDatos(datos);
    setDatos((prevState) => ({
      ...prevState,
      dni: `${datos.dni}${user.letniep}`,
      codSolicitud: datos?.codSolicitud,
    }));
  };

  useEffect(() => {
    const dt = new Date();

    //nuevo
    //   
    //   setDatos((prevState) => ({
    //     ...prevState,
    //     nombre: user.nombre,
    //     ape1: user.apellido1,
    //     ape2: user.apellido2,
    //     dni: `${user.niep}${user.letniep}`,
    //   }));
    //   setIsInitialRender({ personal: false, borrador: true });
    //   setLoading(true)

    //borrador
    // setIsInitialRender({ personal: false, borrador: false });
    //Si el usuario actual tiene ya un borrador hecho lo recoge
    getBorrador(user.niep).then((data) => {
      
      if (data.niep != null) {
        setBorrador(data.niep === null ? false : true);
        
        setDatos((prevState) => ({
          ...prevState,
          codSolicitud: data?.codSolicitud ? data?.codSolicitud : 0,
          ape1: data?.apellido1 ? data?.apellido1 : "",
          ape2: data?.apellido2 ? data?.apellido2 : "",
          nombre: data?.nombre ? data?.nombre : "",
          dni: data?.niep ? `${data?.niep}${user?.letniep}` : "",
          email: data?.correoElectronico,
          tlf: data?.telefonoContacto ? data?.telefonoContacto : "",
          domicilio: data?.domicilio ? data?.domicilio : "",
          localidad: data?.localidad ? data?.localidad : "",
          provincia: data?.provincia ? data?.provincia : "",
          cp: data?.codigoPostal ? data?.codigoPostal : "",
          doe:
            data?.doe.length !== 0
              ? data?.doe
              : [
                  {
                    id: Math.round(
                      dt.getTime() / Math.floor(Math.random() * 100)
                    ),
                    value: "",
                  },
                ],
          formacion:
            data?.formacion.length !== 0
              ? data?.formacion
              : [
                  {
                    id: Math.round(
                      dt.getTime() / Math.floor(Math.random() * 100)
                    ),
                    value: "",
                  },
                ],
          transferencia:
            data?.transferencia.length !== 0
              ? data?.transferencia
              : [
                  {
                    id: Math.round(
                      dt.getTime() / Math.floor(Math.random() * 100)
                    ),
                    value: "",
                  },
                ],
          participacion:
            data?.participacion.length !== 0
              ? data?.participacion
              : [
                  {
                    id: Math.round(
                      dt.getTime() / Math.floor(Math.random() * 100)
                    ),
                    value: "",
                  },
                ],
          a1: data.a1,
          a2: data.a2,
          a3: data.a3,
          estado: data.estado,
        }));
        setLoading(true);
      } else {
        setDatos((prevState) => ({
          ...prevState,
          ape1: user.apellido1,
          ape2: user.apellido2,
          nombre: user.nombre,
          dni: `${user.niep}${user.letniep}`,
        }));
        //   setIsInitialRender({ personal: true, borrador: false });
        setLoading(true);
      }
    });
  }, [user]);

  return (
    <>
      <Header></Header>
      <div
        className="container d-flex flex-column min-vh-100 card mt-5"
        id="inicio"
      >
        {loading ? (
          <>
            <div className="my-auto">
              <div className="container-login ">
                <div className="tituloSolicitud">
                  {/* <Titulo titulo={"Anexo"} tipo={"tituloPagina"} /> */}
                  <h2 className="tituloPagina">Anexo</h2>
                  <div className="d-flex align-items-center flex-column">
                    {/* <Titulo
                      titulo={
                        "SOLICITUD DE RECONOCIMIENTO DE NIVEL DE CARRERA PROFESIONAL HORIZONTAL (Ámbito Administración General)"
                      }
                      tipo={"tituloPagina subTituloPagina"}
                    /> */}
                    <h3 className="tituloPagina subTituloPagina">SOLICITUD DE RECONOCIMIENTO DE NIVEL DE CARRERA PROFESIONAL HORIZONTAL (Ámbito Administración General)</h3>
                    <p className="text-third-1">{datos.estado}</p>
                  </div>
                 

                  <div className="infoSolicitud">
                    <div className="instrucciones">
                      <p className="my-3 mx-2">
                        <b>Antes de cumplimentar y enviar esta solicitud, deberá
                        leer las instrucciones pinchando{" "}
                        <Link to="/instruccionesSolicitud" className="verde">
                          aquí
                        </Link></b>
                      </p>

                     
                    </div>
                    <p className="textoInfo p-2">
                      Al amparo de lo previsto en el Decreto 127/2021, de 17 de
                      noviembre, por el que se regula la carrera profesional
                      horizontal y la evaluación del desempeño de los empleados
                      públicos que prestan sus servicios en la Administración
                      General de la Junta de Extremadura (DOE nº 225, de 23 de
                      noviembre de 2021) y conforme a lo dispuesto en el Plan de
                      Valoración para la progresión en el sistema de carrera
                      profesional horizontal vigente, el/la empleado/a público
                      cuyos datos se expresan a continuación, solicita el
                      reconocimiento de nivel de carrera profesional horizontal
                      que corresponda.
                    </p>
                  </div>
                  <div className="datosPersonalesCarrera d-flex flex-column">
                    <div>
                      
                      <div className="d-flex justify-content-between">
                        {/* <Titulo
                          clases={"subSubTituloSolicitud p-2 fw-bold"}
                          tipo={"tituloCard noBg"}
                          titulo={"1. Datos personales"}
                        ></Titulo> */}
                        <div className="subSubTituloSolicitud p-2 fw-bold">
                          <h4 className="tituloh4access tituloCard noBg">1. Datos personales</h4>
                        </div>
                        
                        <p className="p-3 text-third-1">Campo obligatorio *</p>
                      </div>
                     
                    </div>

                    <div className="formulario">
                      {}
                      <Formik
                        enableReinitialize
                        initialValues={{
                          dni: datos?.dni === "" ? "" : datos?.dni,
                          nombre: datos?.nombre === "" ? "" : datos?.nombre,
                          ape1: datos?.ape1 === "" ? "" : datos?.ape1,
                          ape2: datos?.ape2 === "" ? "" : datos?.ape2,
                          domicilio: datos.domicilio,
                          cp: datos?.cp,
                          localidad: datos?.localidad,
                          provincia:
                            datos?.provincia === "" ? "" : datos?.provincia,
                          tlf: datos?.tlf === "" ? "" : datos?.tlf,
                          email: datos?.email === "" ? "" : datos?.email,
                          a1: datos?.a1 ? datos?.a1 : false,
                          a2: datos?.a2 ? datos?.a2 : false,
                          a3: datos?.a3 ? datos?.a3 : false,
                          doe: "",
                          formacion: "",
                          transferencia: "",
                          participacion: "",
                        }}
                        validate={(valores) => {
                          const errores = {};
                          if (
                            valores.domicilio === null ||
                            valores.domicilio === ""
                          ) {
                            errores.domicilio = "Debe introducir un domicilio.";
                          }
                          if (valores.cp === null || valores.cp === "") {
                            errores.cp = "Debe introducir un Código Postal.";
                          }

                          if (
                            !/^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/.test(
                              valores.cp.toString()
                            )
                          ) {
                            errores.cp = "Código postal invalido.";
                          } else {
                            
                          }

                          if (
                            valores.localidad === null ||
                            valores.localidad === ""
                          ) {
                            errores.localidad =
                              "Debe introducir una localidad.";
                          }
                          if (
                            valores.provincia === null ||
                            valores.provincia === ""
                          ) {
                            errores.provincia =
                              "Debe introducir una provincia.";
                          }
                          if (valores.tlf === null || valores.tlf === "") {
                            errores.tlf = "Debe introducir un teléfono.";
                          }
                          if (
                            !/\(?([0-9]{3})\)?([ -]?)([0-9]{3})\2([0-9]{3})$/.test(
                              valores.tlf
                            )
                          ) {
                            errores.tlf =
                              "Error al introducir el número de teléfono.";
                          }
                          if (valores.email === null || valores.email === "") {
                            errores.email = "Debe introducir un email.";
                          }
                          setDisablePresentar(true);
                          return errores;
                        }}
                        onSubmit={(valores) => {
                          
                          setDatos((prevState) => ({
                            ...prevState,
                            dni: datos?.dni?.substring(0, datos.dni.length - 1),
                          }));
                          datos?.doe.filter(
                            (item) => item.value !== "" || item.value !== null
                          );
                          datos?.formacion.filter(
                            (item) => item.value !== "" || item.value !== null
                          );
                          datos?.transferencia.filter(
                            (item) => item.value !== "" || item.value !== null
                          );
                          datos?.participacion.filter(
                            (item) => item.value !== "" || item.value !== null
                          );
                          valores.doe = datos.doe.filter(
                            (item) => item.value !== "" && item.value !== null
                          );
                          valores.formacion = datos?.formacion.filter(
                            (item) => item.value !== "" && item.value !== null
                          );
                          valores.transferencia = datos?.transferencia.filter(
                            (item) => item.value !== "" && item.value !== null
                          );
                          valores.participacion = datos?.participacion.filter(
                            (item) => item.value !== "" && item.value !== null
                          );
                          valores.codSolicitud = datos?.codSolicitud;

                          if (valores.tipo === "submit") {
                            
                            
                            if (borrador) {
                              setLoadingBotonSolicitar(true);
                              updateSolicitudPresentada(valores).then(
                                (data) => {
                                  
                                  setShow({
                                    mensaje: true,
                                    content: data,
                                    tipo: "tituloModal",
                                    boton: "Aceptar ",
                                    destinoAviso: null,
                                    destinoCerrar: "/carrera",
                                    stateParams: {
                                      solPresentada: true,
                                      codSolicitud: datos?.codSolicitud,
                                    },
                                  });
                                  setLoadingBotonSolicitar(false);
                                }
                              );
                            } else {
                              setShow({
                                mensaje: true,
                                content: "¿Desea presentar la solicitud?",
                                tipo: "tituloModal",
                                funcion: presentar,
                                valorFuncion: valores,
                                aviso: true,
                                destinoAviso: null,
                                destinoCerrar: null,
                              });
                            }

                            
                          }

                          if (valores.tipo === "borrador") {
                            
                            

                            if (borrador) {
                              
                              
                              setLoadingBoton(true);
                              updateBorrador(valores).then((data) => {
                                setShow({
                                  mensaje: true,
                                  content: data,
                                  tipo: "tituloModal",
                                  // funcion: mantenerBorrador,
                                  // valorFuncion:valores,
                                  destinoCerrar: null,
                                  destinoAviso: null,
                                });

                                setLoadingBoton(false);
                              });
                              setDatos(datos);
                              setDatos((prevState) => ({
                                ...prevState,
                                dni: `${datos.niep}${user.letniep}`,
                              }));
                              // Setter para que no se quede vacio el borrador y no tener que recargar
                              setBorrador(true);
                            } else {
                              
                              
                              setLoadingBoton(true);
                              insertSolicitudReconocimiento(valores).then(
                                (data) => {
                                  
                                  setShow({
                                    mensaje: true,
                                    content: data,
                                    tipo: "tituloModal",
                                    // funcion: mantenerBorrador,
                                    // valorFuncion:valores,
                                    destinoCerrar: "/solicitudCarrera",
                                    destinoAviso: null,
                                  });
                                  mantenerBorrador(valores);
                                  setLoadingBoton(false);
                                }
                              );
                              // setDatos(datos);
                              // setDatos((prevState) => ({
                              //   ...prevState,
                              //   dni: `${datos.niep}${user.letniep}`,
                              // }));
                              // Setter para que no se quede vacio el borrador y no tener que recargar
                              setBorrador(true);
                            }
                          }
                          // mantenerBorrador(datos)
                        }}
                      >
                        {({ errors, values }) => (
                          <>
                            <Form>
                              <>
                                <div className="formularioDatosPesonalesCarrera p-2">
                                  <div className="dniDP m-2">
                                    <label htmlFor="dni">DNI:</label>
                                    <Field
                                      type="text"
                                      id="dni"
                                      name="dni"
                                      className="form-control"
                                      placeholder="Introduce un código postal"
                                      readOnly
                                      disabled
                                    />
                                    <ErrorMessage
                                      name="dni"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.dni}
                                        </div>
                                      )}
                                    />
                                  </div>

                                  <div className="nombreDP m-2">
                                    <label htmlFor="nombre">Nombre:</label>
                                    <Field
                                      type="text"
                                      id="nombre"
                                      name="nombre"
                                      className="form-control"
                                      placeholder="Introduce un nombre"
                                      readOnly
                                      disabled
                                    />
                                    <ErrorMessage
                                      name="nombre"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.nombre}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="ape1DP m-2">
                                    <label htmlFor="ape1">
                                      Primer Apellido:
                                    </label>
                                    <Field
                                      type="text"
                                      id="ape1"
                                      name="ape1"
                                      className="form-control"
                                      placeholder="Introduce tu primer apellido"
                                      readOnly
                                      disabled
                                    />
                                    <ErrorMessage
                                      name="ape1"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.ape1}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="ape2DP m-2">
                                    <label htmlFor="ape2">
                                      Segundo Apellido:
                                    </label>
                                    <Field
                                      type="text"
                                      id="ape2"
                                      name="ape2"
                                      className="form-control"
                                      placeholder="Introduce tu segundo apellido"
                                      disabled
                                    />
                                  </div>
                                  <div className="domicilioDP m-2">
                                    <label htmlFor="domicilio">
                                      Domicilio <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="domicilio"
                                      name="domicilio"
                                      className="form-control"
                                      placeholder="Introduce tu dirección de domicilio"
                                    />
                                    <ErrorMessage
                                      name="domicilio"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.domicilio}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="localidadCPDP m-2">
                                    <label htmlFor="localidad">
                                      Localidad <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="localidad"
                                      name="localidad"
                                      className="form-control"
                                      placeholder="Introduce tu localidad"
                                    />
                                    <ErrorMessage
                                      name="localidad"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.localidad}
                                        </div>
                                      )}
                                    />
                                    <label className="mt-2" htmlFor="cp">
                                      CP <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="cp"
                                      name="cp"
                                      className="form-control"
                                      placeholder="Introduce tu código postal"
                                    />
                                    <ErrorMessage
                                      name="cp"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.cp}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="provinciaDP m-2">
                                    <label htmlFor="provincia">
                                      Provincia <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="provincia"
                                      name="provincia"
                                      className="form-control"
                                      placeholder="Introduce tu provincia"
                                    />
                                    <ErrorMessage
                                      name="provincia"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.provincia}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="tlfContactoDP m-2">
                                    <label htmlFor="tlf">
                                      Teléfono de contacto{" "}
                                      <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="tlf"
                                      name="tlf"
                                      className="form-control"
                                      placeholder="Introduce tu teléfono de contacto"
                                    />
                                    <ErrorMessage
                                      name="tlf"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.tlf}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="emailDP m-2">
                                    <label htmlFor="email">
                                      Correo electrónico de contacto{" "}
                                      <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="email"
                                      name="email"
                                      className="form-control"
                                      placeholder="Introduce tu correo electrónico de contacto"
                                    />
                                    <ErrorMessage
                                      name="email"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.email}
                                        </div>
                                      )}
                                    />
                                  </div>
                                </div>
                              </>

                              <div className="relacionMeritos">
                                
                                {/* <Titulo
                                  clases={"subSubTituloSolicitud p-2 fw-bold"}
                                  tipo={"tituloCard noBg"}
                                  titulo={
                                    "2. Relación de méritos para alcanzar la puntuación mínima necesaria para superar el proceso de valoración:"
                                  }
                                ></Titulo> */}
                                <div className="subSubTituloSolicitud p-2 fw-bold">
                                  <h4 className="tituloh4access tituloCard noBg">2. Relación de méritos para alcanzar la puntuación mínima necesaria para superar el proceso de valoración:</h4>
                                </div>
                              
                                <div className="meritosComprobar">
                                
                                  {/* <Titulo
                                    clases={"subSubTituloSolicitud p-2 fw-bold"}
                                    tipo={"tituloCard noBg"}
                                    titulo={
                                      "2.A) Méritos a comprobar de oficio:"
                                    }
                                  ></Titulo> */}
                                  <div className="subSubTituloSolicitud p-2 fw-bold">
                                    <h4 className="tituloh4access tituloCard noBg">2.A) Méritos a comprobar de oficio</h4>
                                  </div>
                                  
                                  <div className="p-2">
                                    <Field
                                      type="checkbox"
                                      id="a1"
                                      name="a1"
                                      className="form-check-input"
                                    />{" "}
                                    A.1- Formación continua recibida y docencia
                                    impartida en la Escuela de Administración
                                    Pública de Extremadura (EAP).
                                    <p>
                                      Formación certificada por la EAP que se
                                      deberá marcar si el/la solicitante quiere
                                      que se le valore.
                                    </p>
                                    <p className="fw-bold">
                                      NO SE APORTARÁ DOCUMENTACIÓN.
                                    </p>
                                    <Field
                                      type="checkbox"
                                      id="a2"
                                      name="a2"
                                      className="form-check-input"
                                    />{" "}
                                    A.2- Puestos de trabajo de especial
                                    desempeño.
                                    <p>
                                      Son aquellos puestos de trabajo que reunen
                                      alguna de las circunstancias establecidas
                                      en el Plan de Valoración.
                                    </p>
                                    <p className="fw-bold">
                                      NO SE APORTARÁ DOCUMENTACIÓN.
                                    </p>
                                    <Field
                                      type="checkbox"
                                      id="a3"
                                      name="a3"
                                      className="form-check-input gestion-check-input"
                                    />{" "}
                                    A.3- Participación en órganos de selección
                                    y/o provisión del personal de la
                                    Administración de la Junta de Extremadura.
                                    <p>
                                      Se valorará la participación en calidad de
                                      presidente/a, secretario/a, vocal o
                                      asesor/a de los órganos de selección y
                                      provisión de la Administración General de
                                      la Junta de Extremadura. La persona
                                      solicitante deberá indicar, en su caso, el
                                      DOE de su nombramiento o de la publicación
                                      de la convocatoria de provisión.
                                    </p>
                                    <p>
                                      La persona solicitante deberá indicar, en
                                      su caso, el DOE de su nombramiento o de la
                                      publicación de la convocatoria de
                                      provisión.
                                    </p>
                                    <p className="fw-bold">
                                      NO SE APORTARÁ DOCUMENTACIÓN.
                                    </p>
                                    <div className="d-flex flex-column">
                                      {datos.doe.map((input, i) => (
                                        <div key={i}>
                                          {doeMostrar ? (
                                            <>
                                              <label
                                                className="mt-2"
                                                htmlFor="doe"
                                              >
                                                DOE:
                                              </label>
                                              <div className="d-flex">
                                                <input
                                                  type="text"
                                                  name="doe"
                                                  placeholder="Diario oficial de Extremadura"
                                                  className="form-control mt-2"
                                                  id={input.id}
                                                  defaultValue={input.value}
                                                  onChange={(event) => {
                                                    input.value =
                                                      event.target.value;
                                                  }}
                                                />
                                                <i
                                                  className="fa-solid fa-remove fs-1 mx-2 text-third-1 px-3 pt-2 cursorPointer "
                                                  onClick={() => {
                                                    eliminarGeneral(
                                                      input.id,
                                                      setDoeMostrar,
                                                      datos.doe,
                                                      "doe"
                                                    );
                                                  }}
                                                  role="button"
                                                  title="Eliminar DOE"
                                                  aria-label="Eliminar DOE"
                                                  tabIndex={0}
                                                  onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                      eliminarGeneral(
                                                        input.id,
                                                        setDoeMostrar,
                                                        datos.doe,
                                                        "doe"
                                                      );
                                                    }
                                                  }}
                                                ></i>
                                              </div>
                                            </>
                                          ) : (
                                            <SpinnerCircleMini></SpinnerCircleMini>
                                          )}
                                        </div>
                                      ))}
                                      <br/>
                                      <div onClick={() => {
                                          anadirInput(datos.doe);
                                        }}
                                        role="button"
                                        title="Añadir nueva seccion DOE"
                                        aria-label="Añadir nueva seccion DOE"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter" || e.key === " ") {
                                            anadirInput(datos.doe);
                                          }
                                        }}
                                        >
                                        
                                         <i className="fa-solid fa-add  mx-2 text-success  cursorPointer">
                                              <span className="text-success">
                                                <b>Añadir</b>
                                              </span>
                                            </i>
                                           
                                        </div>
                                      
                                    </div>
                                  </div>
                                </div>
                                <div className="meritosAcreditados">
                                  
                                  {/* <Titulo
                                    clases={"subSubTituloSolicitud p-2 fw-bold"}
                                    tipo={"tituloCard noBg"}
                                    titulo={
                                      "2.B)  Méritos que deben ser acreditados por el/la interesado/a:"
                                    }
                                  ></Titulo> */}
                                   <div className="subSubTituloSolicitud p-2 fw-bold">
                                    <h4 className="tituloh4access tituloCard noBg">2.B)  Méritos que deben ser acreditados por el/la interesado/a:</h4>
                                  </div>
                                
                                  <p className="textoInfo p-2">
                                    Si la persona solicitante cumplimenta alguno
                                    de estos apartados, deberá describir el
                                    mérito alegado, imprimir esta solicitud y
                                    enviarla, junto con los correspondientes
                                    certificados acreditativos, a la Dirección
                                    General de Función Pública, a través de
                                    alguno de los registros administrativos
                                    habilitados al efecto. En el caso de la
                                    formación continua y docencia el certificado
                                    deberá indicar el número de créditos/horas,
                                    en caso contrario, no serán objeto de
                                    valoración.
                                  </p>
                                  <div className="formacion">
                               
                                    {/* <Titulo
                                      clases={
                                        "subSubTituloSolicitud p-2 fw-bold"
                                      }
                                      tipo={"tituloCard noBg"}
                                      titulo={
                                        "B.1.- Formación (no impartida por la EAP):"
                                      }
                                    ></Titulo> */}
                                    <div className="subSubTituloSolicitud p-2 fw-bold">
                                      <h4 className="tituloh4access tituloCard noBg">B.1.- Formación (no impartida por la EAP):</h4>
                                    </div>
                                    
                                    <div className="d-flex flex-column p-2">
                                      {datos?.formacion.map((input, i) => (
                                        <div key={i}>
                                          {formacionMostrar ? (
                                            <div className="d-flex">
                                              <input
                                                type="text"
                                                name=""
                                                className="form-control mt-2"
                                                id={input.id}
                                                defaultValue={input.value}
                                                placeholder="Introduce tu formación"
                                                onChange={(event) =>
                                                  (input.value =
                                                    event.target.value)
                                                }
                                              />
                                              <i
                                                className="fa-solid fa-remove fs-1 mx-2 text-danger px-3 pt-2 cursorPointer "
                                                onClick={() => {
                                                  eliminarGeneral(
                                                    input.id,
                                                    setFormacionMostrar,
                                                    datos.formacion,
                                                    "formacion"
                                                  );
                                                }}
                                                role="button"
                                                title="Eliminar formación"
                                                aria-label="Eliminar formación"
                                                tabIndex={0}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter" || e.key === " ") {
                                                    eliminarGeneral(
                                                      input.id,
                                                      setFormacionMostrar,
                                                      datos.formacion,
                                                      "formacion"
                                                    );
                                                  }
                                                }}
                                              ></i>
                                            </div>
                                          ) : (
                                            <SpinnerCircleMini></SpinnerCircleMini>
                                          )}
                                        </div>
                                      ))}
                                      <br/>
                                      <div onClick={() => {
                                           anadirInput(datos.formacion);
                                        }}
                                        role="button"
                                        title="Añadir nueva seccion de formación"
                                        aria-label="Añadir nueva seccion de formación"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter" || e.key === " ") {
                                            anadirInput(datos.formacion);
                                          }
                                        }}
                                        >
                                         <i className="fa-solid fa-add mx-2 text-success  cursorPointer">
                                              <span className="text-success">
                                                <b>Añadir</b>
                                              </span>
                                            </i>
                                        </div>
                                      
                                    </div>
                                  </div>
                                  <div className="trasnferencia">
                                   
                                    {/* <Titulo
                                      clases={
                                        "subSubTituloSolicitud p-2 fw-bold"
                                      }
                                      tipo={"tituloCard noBg"}
                                      titulo={
                                        "B.2.- Transferencia, innovacion y difusión de conocimientos:"
                                      }
                                    ></Titulo> */}
                                    <div className="subSubTituloSolicitud p-2 fw-bold">
                                      <h4 className="tituloh4access tituloCard noBg">B.2.- Transferencia, innovacion y difusión de conocimientos:</h4>
                                    </div>
                                  
                                    <div className="d-flex flex-column p-2">
                                      {datos?.transferencia.map((input, i) => (
                                        <div key={i}>
                                          {transferenciaMostrar ? (
                                            <div className="d-flex">
                                              <input
                                                type="text"
                                                name=""
                                                className="form-control mt-2"
                                                placeholder="Introduce tus datos en referencia a transferencia, innovacion y difusión de conocimientos"
                                                id={input.id}
                                                defaultValue={input.value}
                                                onChange={(event) =>
                                                  (input.value =
                                                    event.target.value)
                                                }
                                              />
                                              <i
                                                className="fa-solid fa-remove fs-1 mx-2 text-danger px-3 pt-2 cursorPointer "
                                                onClick={() => {
                                                  eliminarGeneral(
                                                    input.id,
                                                    setTransferenciaMostrar,
                                                    datos.transferencia,
                                                    "transferencia"
                                                  );
                                                }}
                                                role="button"
                                                title="Eliminar transferencia"
                                                aria-label="Eliminar transferencia"
                                                tabIndex={0}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter" || e.key === " ") {
                                                    eliminarGeneral(
                                                      input.id,
                                                      setTransferenciaMostrar,
                                                      datos.transferencia,
                                                      "transferencia"
                                                    );
                                                  }
                                                }}
                                              ></i>
                                            </div>
                                          ) : (
                                            <SpinnerCircleMini></SpinnerCircleMini>
                                          )}
                                        </div>
                                      ))}
                                      <br/>
                                    <div onClick={() => {
                                           anadirInput(datos.transferencia);
                                        }}
                                        role="button"
                                        title="Añadir nueva seccion de transferencia"
                                        aria-label="Añadir nueva seccion de transferencia"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter" || e.key === " ") {
                                            anadirInput(datos.transferencia);
                                          }
                                        }}
                                        >
                                         <i className="fa-solid fa-add mx-2 text-success  cursorPointer">
                                              <span className="text-success">
                                                <b>Añadir</b>
                                              </span>
                                            </i>
                                        </div>
                                     
                                    </div>
                                  </div>
                                  <div className="participacion">
                                   
                                    {/* <Titulo
                                      clases={
                                        "subSubTituloSolicitud p-2 fw-bold"
                                      }
                                      tipo={"tituloCard noBg"}
                                      titulo={
                                        "B.3.- Participación en tribunales de las corporaciones locales en calidad de representante de la Administración General de la Junta de Extremadura."
                                      }
                                    ></Titulo> */}
                                    <div className="subSubTituloSolicitud p-2 fw-bold">
                                      <h4 className="tituloh4access tituloCard noBg">B.3.- Participación en tribunales de las corporaciones locales en calidad de representante de la Administración General de la Junta de Extremadura.</h4>
                                    </div>
                                   
                                    <p className="textoInfo p-2">
                                      La persona solicitante deberá indicar el
                                      BOP de su nombramiento.
                                    </p>
                                    <div className="d-flex flex-column p-2">
                                      {datos?.participacion.map((input, i) => (
                                        <div key={i}>
                                          {participacionMostrar ? (
                                            <div className="d-flex">
                                              <input
                                                type="text"
                                                name=""
                                                className="form-control mt-2"
                                                id={input.id}
                                                placeholder="Introduce tu participación"
                                                defaultValue={input.value}
                                                onChange={(event) =>
                                                  (input.value =
                                                    event.target.value)
                                                }
                                              />
                                              <i
                                                className="fa-solid fa-remove fs-1 mx-2 text-danger px-3 pt-2 cursorPointer "
                                                onClick={() => {
                                                  eliminarGeneral(
                                                    input.id,
                                                    setParticipacionMostrar,
                                                    datos.participacion,
                                                    "participacion"
                                                  );
                                                }}
                                                role="button"
                                                title="Eliminar participación"
                                                aria-label="Eliminar participación"
                                                tabIndex={0}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter" || e.key === " ") {
                                                    eliminarGeneral(
                                                      input.id,
                                                      setParticipacionMostrar,
                                                      datos.participacion,
                                                      "participacion"
                                                    );
                                                  }}}
                                              ></i>
                                            </div>
                                          ) : (
                                            <SpinnerCircleMini></SpinnerCircleMini>
                                          )}
                                        </div>
                                      ))}
                                       <br/>
                                    <div onClick={() => {
                                           anadirInput(datos.participacion);
                                        }}
                                    role="button"
                                    title="Añadir nueva sección de participación"
                                    aria-label="Añadir nueva sección de participación"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" || e.key === " ") {
                                        anadirInput(datos.participacion);
                                      }
                                    }}>
                                         <i className="fa-solid fa-add  mx-2 text-success  cursorPointer">
                                              <span className="text-success">
                                                <b>Añadir</b>
                                              </span>
                                            </i>
                                        </div>
                                  
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="footer">
                                <p className="p-2">
                                  En cumplimiento de lo dispuesto en la Ley
                                  Orgánica 3/2018, de 5 de diciembre, de
                                  protección de datos personales y garantía de
                                  los derechos digitales, la Consejería de
                                  Hacienda y Administración Pública le informa
                                  que los datos de carácter personal recogidos
                                  en esta solicitud van a ser tratados con la
                                  finalidad de que le sea reconocido el nivel de
                                  carrera profesional horizontal que
                                  corresponda. El responsable del tratamiento de
                                  estos datos será la Consejería de Hacienda y
                                  Administración Pública. Las personas
                                  interesadas podrán ejercitar los derechos de
                                  acceso, rectificación, cancelación, supresión,
                                  limitación del tratamiento y oposición
                                  establecidos en los artículos 12 a 18 de la
                                  referida Ley Orgánica, mediante escrito
                                  dirigido a la Dirección General de Función
                                  Pública (Avda. Valhondo s/n, Edificio III
                                  Milenio, Módulo 1- 1ª planta. 06800 - MÉRIDA)
                                </p>
                                <div className="direccion d-flex flex-column align-items-center m-2 text-center">
                                  <p>DIRECCIÓN GENERAL DE FUNCIÓN PÚBLICA</p>
                                  <p className="text-center">
                                    Avda. Valhondo, s/n Edificio III Milenio -
                                    Módulo 1 - 1ª Planta - 06800 Mérida
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex mb-2 flex-sm-row flex-column">
                                <button
                                  id="guardarSolicitudCarrera"
                                  className="btnRed rounded m-2"
                                  type="button"
                                  onClick={() =>
                                    setShow({
                                      mensaje: true,
                                      content:
                                        "¿Deseas cancelar el formulario?",
                                      tipo: "tituloModal",
                                      aviso: true,
                                      destinoAviso: "/carrera",
                                      destinoCerrar: null,
                                    })
                                  }
                                >
                                  <i className="fa-solid fa-cancel"></i>{" "}
                                  Cancelar
                                </button>
                                {accesoConcurso ? (
                                  <>
                                    <button
                                      id="grabarSolicitudCarrera"
                                      className="btn m-2 rounded"
                                      type="submit"
                                      onClick={
                                        Object.keys(errors).length === 0
                                          ? () => {
                                              values.tipo = "borrador";
                                            }
                                          : () => {
                                              setShow({
                                                mensaje: true,
                                                content:
                                                  "Debe completar correctamente los datos obligatorios (Datos personales).",
                                                tipo: "tituloModal rojo",
                                                destinoCerrar: null,
                                                destinoAviso: null,
                                              });
                                            }
                                      }
                                      disabled={
                                        borrador === false &&
                                        !disablePresentar &&
                                        loadingBoton
                                      }
                                    >
                                      {}
                                      {loadingBoton ? (
                                        <div className="d-flex justify-content-center ">
                                          <SpinnerCircleMini />
                                        </div>
                                      ) : (
                                        <>
                                          <i className="fa-solid fa-save"></i>{" "}
                                          Grabar
                                        </>
                                      )}
                                    </button>
                                    <button
                                      id="presentarSolicitudCarrera"
                                      className="btn m-2 rounded"
                                      type="submit"
                                      onClick={
                                        Object.keys(errors).length === 0
                                          ? () => {
                                              values.tipo = "submit";
                                            }
                                          : () => {
                                              setShow({
                                                mensaje: true,
                                                content:
                                                  "Debe completar correctamente los datos obligatorios (Datos personales).",
                                                tipo: "tituloModal rojo",
                                                destinoCerrar: null,
                                                destinoAviso: null,
                                              });
                                            }
                                      }
                                      disabled={
                                        borrador === false &&
                                        !disablePresentar &&
                                        loadingBotonSolicitar
                                      }
                                    >
                                      {}
                                      {loadingBotonSolicitar ? (
                                        <div className="d-flex justify-content-center ">
                                          <SpinnerCircleMini />
                                        </div>
                                      ) : (
                                        <>
                                          <i className="fa-solid fa-file-circle-plus"></i>{" "}
                                          Solicitar
                                        </>
                                      )}
                                    </button>
                                  </>
                                ) : null}
                              </div>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              {/* {estado ? (
                    <>
                      {estadoError}
                      <Button
                        id="btnCerrarConsultaIRPF"
                        clases="btn-card mt-3"
                        nombre="Volver"
                        tipo="button"
                        funcion={() => {
                          navigate("/home");
                        }}
                      />
                    </>
                  ) : (
                    <SpinnerCircle></SpinnerCircle>
                  )} */}
            </div>
          </>
        )}
      </div>
      <Footer></Footer>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.titulo}
          content={show.content}
          tipo={show.tipo}
          aviso={show.aviso}
          destinoAviso={show.destinoAviso}
          funcion={show.funcion}
          valorFuncion={show.valorFuncion}
          boton={show.boton}
          destinoCerrar={show?.destinoCerrar}
          stateParams={show?.stateParams}
        ></ModalMensajes>
      ) : null}
    </>
  );
};
export default SolicitudCarrera;
